module.exports = __webpack_public_path__ + "static/img/theme3.722f6cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme3.jpg
// module id = FfuN
// module chunks = 0